<script setup lang="ts">
import { useI18n } from 'vue-i18n'

const t = useI18n().t
const model = defineModel<number | 'linear' | 'none' | 'previous' | null>({ default: null })

const items = [
  { value: 0, title: t('chart_sharing.creator.customize.fill.zero') },
  { value: 'linear', title: t('chart_sharing.creator.customize.fill.linear') },
  { value: 'none', title: t('chart_sharing.creator.customize.fill.none') },
  { value: 'previous', title: t('chart_sharing.creator.customize.fill.previous') },
  { value: null, title: t('chart_sharing.creator.customize.fill.null') },
]
</script>

<template>
  <v-autocomplete
    v-model="model"
    prepend-icon="mdi-format-color-fill"
    :label="$t('chart_sharing.creator.customize.fill.title')"
    variant="outlined"
    :items="items"
    item-value="value"
    item-title="title"
    hide-details
  />
</template>
